import gql from 'graphql-tag'

// Admin Queries

export const GET_ADMIN_INBOXES = gql`
  query GetAdminInboxes($first: Int, $after: String, $isArchived: Boolean) {
    myAdminInboxes(first: $first, after: $after, isArchived: $isArchived) {
      edges {
        node {
          id
          name
          isArchived
          channelsCount
          membersCount
          dateAdded
          dateModified
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ADMIN_CHANNELS = gql`
  query GetAdminChannels($first: Int, $after: String, $inbox: ID, $isArchived: Boolean) {
    allChannels(first: $first, after: $after, inbox: $inbox, isArchived: $isArchived) {
      edges {
        node {
          id
          name
          channelType
          sendAs
          isArchived
          inbox {
            id
            name
          }
          dateAdded
          dateModified
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ADMIN_INBOX_MEMBERS = gql`
  query GetAdminInboxMembers($first: Int, $after: String, $inbox: ID, $searchTerm: String) {
    allInboxMembers(first: $first, after: $after, inbox: $inbox, searchTerm: $searchTerm) {
      edges {
        node {
          id
          role
          canBeAssigned
          user {
            id
            username
            email
            firstName
            lastName
          }
          inbox {
            id
            name
          }
          dateAdded
          dateModified
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ADMIN_INBOX_GROUP_ACCESSES = gql`
  query GetAdminInboxGroupAccesses($first: Int, $after: String, $inbox: ID, $searchTerm: String) {
    allInboxGroupAccesses(first: $first, after: $after, inbox: $inbox, searchTerm: $searchTerm) {
      edges {
        node {
          id
          role
          canBeAssigned
          group {
            id
            name
          }
          inbox {
            id
            name
          }
          dateAdded
          dateModified
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query GetAllUsers($first: Int, $after: String, $username: String, $email: String) {
    allMembers(first: $first, after: $after, user_Username_Icontains: $username, searchTerm: $email) {
      edges {
        node {
          id
          user {
            id
            username
            email
            firstName
            lastName
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;


export const GET_MESSAGE_TEMPLATES = gql`
  query GetAdminMessageTemplates($first: Int, $after: String, $isActive: Boolean) {
    allMessageTemplates(first: $first, after: $after, isActive: $isActive) {
      edges {
        node {
          id
          title
          content
          contentHtml
          shortcut
          isActive
          dateAdded
          dateModified
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ADMIN_TOPICS = gql`
  query GetAdminTopics($first: Int) {
    allTopics(first: $first) {
      edges {
        node {
          id
          name
          description
          dateModified
        }
      }
    }
  }
`;

export const IS_INBOX_ADMIN = gql`
  query IsInboxAdmin {
    isInboxAdmin
  }
`;

export const GET_CHANNEL_TYPES = gql`
  query GetChannelTypes {
    __type(name: "ChannelChannelTypeChoices") {
      enumValues {
        name
        description
      }
    }
  }
`;
